// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/sdk/debugger/:app_group_id/all" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { sdkDebuggerAppGroupIdAll } from "./constants";
import type { SdkDebuggerAppGroupIdAllParams, SdkDebuggerAppGroupIdAllResult } from "./types";

export const getDataTableSdkDebuggerAppGroupIdAll = reactQueryTableFetcherAdapter(
  sdkDebuggerAppGroupIdAll,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: SdkDebuggerAppGroupIdAllParams
  ): Promise<SdkDebuggerAppGroupIdAllResult> => {
    return fetch(
      `/sdk/debugger/${appGroupId}/all`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
